<template>
  <div class="loader">
    <!-- george loading spinner -->
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="32"
      height="32"
      fill="#415b76"
    >
      <use href="#ico-loader" xlink:href="#ico-loader" />
    </svg>

    <!-- text -->
    <p
      v-if="$t('interface.loader') !== 'interface.loader'"
      v-html="$t('interface.loader')"
    />
  </div>
</template>

<style lang="scss">
@use '@/assets/scss/colors.scss';
@use '@/assets/scss/variables.scss';
@use '@/assets/scss/mixins.scss';

.loader {
  position: fixed;
  z-index: 5000;
  width: 100%;
  height: 100%;

  background-color: colors.$eg-grey;

  display: flex;
  flex-direction: column;
  justify-content: top;
  align-items: center;

  svg {
    margin-top: mixins.calculateRem(variables.$spacingHeaderContent * 2);
  }

  p {
    margin-top: mixins.calculateRem(variables.$spacingHeaderContent);

    @include mixins.fontSize(28px);
    @include mixins.lineHeight(40px);
    font-weight: 300;
    color: colors.$g-primary-900;
    text-align: center;
  }
}
</style>
